import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NotificationEmailConfiguration } from '../../Models/Domains/Threads/NotificationEmailConfiguration';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationAlertEmaiAddressesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<NotificationEmailConfiguration, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/NotificationAlertEmaiAddresses/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<NotificationEmailConfiguration, any>(url, data);
  }
  public put(emailConfiguration: NotificationEmailConfiguration): Promise<NotificationEmailConfiguration, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/NotificationAlertEmaiAddresses/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { emailConfiguration: emailConfiguration }

    return AjaxWrapper.put<NotificationEmailConfiguration, any>(url, data);
  }
}

